export default __webpack_public_path__ + "static/media/cake1.a8bac8a4.jpg";